export default __webpack_public_path__ + "static/Turbo-1178752929ebf9c32033f1379510d543.gif";